// extracted by mini-css-extract-plugin
export default {"section":"BenefitSection_section__UcNuZ","title":"BenefitSection_title__NuBFt","list":"BenefitSection_list__KqVU1"};